export const AI_DISCLAIMER_MODULE_ID = 'email_ai_disclaimer';
export const AI_DYNAMIC_TOKEN_PATTERN = /{{-?\s*ai_dynamic_token\(\s*["']?([\w_]+)["']?\s*\)\s*-?}}/g;